<template>
  <div class="flex flex-col gap-2">
    <span class="secondary_color text-[13px] mt-5"
      >Define qualification criteria</span
    >
    <a-textarea
      v-model:value="modelValue.instruction"
      class="textarea_large"
      :rows="4"
      placeholder="Enter criteria"
    />
  </div>
</template>

<script setup>
defineProps({
  modelValue: { type: Object, required: true },
});
</script>
